import React from "react";
import Modal, { ModalProps } from "components/Modal";
import { useTranslation } from "react-i18next";
import {
  CONSULTATION_CALENDAR_URL,
  PRICES_OVERVIEW_URL,
  REQUEST_OFFER_URL,
  SOFTWARE_EMAIL,
} from "utils";
import VideoCallImage from "assets/images/illustration_video_call.svg";
import ContractImage from "assets/images/illustration_contract.svg";
import { IconCopy, IconExternalLink } from "@tabler/icons-react";
import clsx from "clsx";
import useToast from "hooks/useToast";

const MakeContactModal = (props: ModalProps) => {
  const { t } = useTranslation();
  const toast = useToast();

  const tileStyle =
    "shadow-base p-6 border border-gray-200 hover:border-indigo-600 rounded-md hover:bg-indigo-50 transition cursor-pointer";

  const openLink = (url: string | undefined) => {
    window.open(url, "_blank");
  };

  const copyEmail = async () => {
    await navigator.clipboard.writeText(SOFTWARE_EMAIL);
    toast(t("dashboard.emailCopiedMessage"), "success");
  };

  return (
    <Modal
      isOpen={props.open}
      setIsOpen={props.close}
      title={t("dashboard.makeContactTitle")}
      containerClassName="min-w-[768px]"
      closeButton
    >
      <div className="p-6">
        <div className="grid grid-cols-2 gap-6">
          <div
            className={tileStyle}
            onClick={() => openLink(CONSULTATION_CALENDAR_URL)}
          >
            <div className="font-semibold text-gray-900 text-base mb-6">
              {t("dashboard.arrangeConsultation")}
            </div>
            <div className="mb-6 justify-center flex">
              <img src={VideoCallImage} alt="Video-call" />
            </div>
            <div className="text-base font-medium text-gray-600">
              {t("dashboard.arrangeConsultationDesc")}
            </div>
          </div>

          <div
            className={tileStyle}
            onClick={() => openLink(REQUEST_OFFER_URL)}
          >
            <div className="font-semibold text-gray-900 text-base mb-6">
              {t("dashboard.angebotAnfordern")}
            </div>
            <div className="mb-6 justify-center flex">
              <img src={ContractImage} alt="Video-call" />
            </div>
            <div className="text-base font-medium text-gray-600">
              {t("dashboard.angebotAnfordernDesc")}
            </div>
          </div>
        </div>
        <div className="flex flex-col items-center">
          <div
            className="text-sm font-medium text-gray-600 mt-6"
            dangerouslySetInnerHTML={{
              __html: t("dashboard.makeContactDesc", {
                email: SOFTWARE_EMAIL,
              }),
            }}
          ></div>
          <div className="flex gap-6">
            <div
              onClick={copyEmail}
              className={clsx(
                "text-xs font-semibold text-indigo-700 mt-3 flex items-center cursor-pointer hover:text-indigo-500"
              )}
            >
              {t("dashboard.copyEmailAddress")}
              <IconCopy stroke={3} size={16} className="ml-1" />
            </div>
            <div
              onClick={() => openLink(PRICES_OVERVIEW_URL)}
              className={clsx(
                "text-xs font-semibold text-indigo-700 mt-3 flex items-center cursor-pointer hover:text-indigo-500"
              )}
            >
              {t("dashboard.watchPriceOverview")}
              <IconExternalLink stroke={3} size={16} className="ml-1" />
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default MakeContactModal;
